import React from 'react';
import styled from '@emotion/styled/macro';
import StyledOpeningParagraph from '@components/masthead/opening-paragraph';
import vars from '@variables';
import { defineResponsiveGridColumns } from '@utils/utils';
import { IndentWrapperProps } from './indent-wrapper.types';
import {
  SimplecastEmbedAtom,
  YouTubeEmbedAtom,
} from '@atoms/media-atoms/media-atoms';

export const IndentWrapper: React.FC<IndentWrapperProps> = ({
  openingParagraph,
  mediaSrc,
  className,
}) => {
  if (openingParagraph === null && mediaSrc === null) return null;

  let indentContent;
  if (openingParagraph && openingParagraph.length > 0)
    indentContent = (
      <StyledOpeningParagraph
        data-testid="mast-paragraph"
        openingParagraph={openingParagraph}
      />
    );
  if (mediaSrc && mediaSrc.length > 0) {
    if (mediaSrc.includes('youtube') || mediaSrc.includes('youtu.be')) {
      indentContent = (
        <YouTubeEmbedAtom
          src={mediaSrc}
          className={className}
        ></YouTubeEmbedAtom>
      );
    }
    if (mediaSrc.includes('simplecast'))
      indentContent = (
        <SimplecastEmbedAtom
          src={mediaSrc}
          width="100%"
          className={className}
        ></SimplecastEmbedAtom>
      );
  }
  return <StyledIndentWrapper>{indentContent}</StyledIndentWrapper>;
};

const StyledIndentWrapper = styled.div`
  display: grid;
  width: 100%;
  margin: 0 auto;
  max-width: ${vars.mainMaxWidth};
  column-gap: ${vars.mobileColumnPercentageGap};
  grid-template-columns: ${defineResponsiveGridColumns(4)};

  @media screen and (min-width: ${vars.breakPointTablet}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(8)};
  }

  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(12)};
  }

  ${YouTubeEmbedAtom}, ${SimplecastEmbedAtom}, ${StyledOpeningParagraph} {
    grid-column: col1-start / col4-end;
    margin-bottom: ${vars.spacingS};

    @media screen and (min-width: ${vars.breakPointTablet}) {
      grid-column: col2-start / col7-end;
      margin-bottom: ${vars.spacingS};
    }

    @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
      grid-column: col3-start / col10-end;
      margin-bottom: ${vars.spacingS};
    }
  }

  ${StyledOpeningParagraph} {
    margin-bottom: 0;
  }

  ${YouTubeEmbedAtom} {
    border-radius: 8px;
  }
`;
